import { MobileCommExAppControlTable } from "../MobileCommExAppControlTable";
import { Layout, LayoutHeader, Splitter, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppList extends Layout {
    layoutExternalApplicationsControlByTable: MobileCommExAppControlTable;
    layoutheaderExternalApplicationsControlList: LayoutHeader;
    splitterExternalApplicationsControlList: Splitter;
    textboxDateRange: Textbox;
}
